import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import type { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface UnauthorizedSnackbarProps {
  open: boolean;
  onClose: () => void;
  message?: string;
}

const UnauthorizedSnackbar: React.FC<UnauthorizedSnackbarProps> = ({ open, onClose, message }) => {
  return (
    <Snackbar open={open} autoHideDuration={4000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert onClose={onClose} severity="warning" sx={{ width: '100%' }}>
        {message || 'You are not logged in or do not have sufficient privileges to perform this action.'}
      </Alert>
    </Snackbar>
  );
};

export default UnauthorizedSnackbar; 